import { render, staticRenderFns } from "./otherGames.vue?vue&type=template&id=f7f88a1c&"
import script from "./otherGames.vue?vue&type=script&lang=js&"
export * from "./otherGames.vue?vue&type=script&lang=js&"
import style0 from "./otherGames.vue?vue&type=style&index=0&id=f7f88a1c&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports